module.exports = __webpack_public_path__ + "img/robo-klaus-1.b24a9b45.png";